import {Configuration, PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {PropsWithChildren, useEffect} from 'react';

import {AzureAuthConfig} from 'core/types';

import {setAzureAuthInstance, useAuthStore} from 'core/stores/auth';

import {AzureAuthProviderInternal} from './AzureAuthProviderInternal';

export const AzureAuthProvider = ({children, authConfig}: PropsWithChildren<{authConfig?: AzureAuthConfig}>) => {
  const pcaInstance = useAuthStore(store => store.azureAuthInstance);

  useEffect(() => {
    if (authConfig) {
      const configuration: Configuration = {
        auth: {
          clientId: authConfig.clientId,
          authority: authConfig.authority,
          redirectUri: window.location.origin,
        },
      };

      const instance = new PublicClientApplication(configuration);
      setAzureAuthInstance(instance);
    }
  }, [authConfig]);

  if (!pcaInstance) {
    return children;
  }

  return (
    <MsalProvider instance={pcaInstance}>
      <AzureAuthProviderInternal>{children}</AzureAuthProviderInternal>
    </MsalProvider>
  );
};
